import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ADMIN_SHEET_OVERLAY_PROVIDERS } from '@shared/utils/admin-sheet-overlay.providers';
import { POS_PROVIDERS } from '../../../pos.providers';
import {
  PosHubOrderDetailPanelComponent,
  PosHubOrderDetailResult,
} from '../../components/pos-hub-order-detail-panel/pos-hub-order-detail-panel.component';

export interface PosHubOrderDetailSheetData {
  readonly orderId: string;
}

/**
 * Sheet lateral del detalle de pedido (misma UI que Pedidos → Completados).
 * Se abre desde Finanzas u otros módulos vía {@link PosOrderTxDetailOpenerService}.
 */
@Component({
  selector: 'app-pos-hub-order-detail-sheet',
  standalone: true,
  imports: [MatDialogModule, PosHubOrderDetailPanelComponent],
  providers: [...ADMIN_SHEET_OVERLAY_PROVIDERS, ...POS_PROVIDERS],
  template: `
    <app-pos-hub-order-detail-panel
      [orderId]="data.orderId"
      (closed)="onClosed($event)"
    />
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        height: 100%;
        min-height: 0;
        padding: 1.15rem 1.15rem 1.05rem;
        overflow: hidden;
      }

      :host > * {
        flex: 1 1 auto;
        min-width: 0;
        min-height: 0;
        width: 100%;
      }
    `,
  ],
})
export class PosHubOrderDetailSheetComponent {
  readonly data = inject<PosHubOrderDetailSheetData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(
    MatDialogRef<PosHubOrderDetailSheetComponent, PosHubOrderDetailResult | void>,
  );

  onClosed(result: PosHubOrderDetailResult): void {
    this.dialogRef.close(result);
  }
}
